// Cache léger des réponses GET (chiffres de tableaux de bord) pour ouverture instantanée hors-ligne / réseau lent.
const PREFIX = "bvd_cache:";
const MAX_BYTES = 250_000;
const TTL_MS = 7 * 24 * 3600 * 1000;
const SKIP = ["/auth", "/me", "/admin/", "/codes", "/activer", "/kobo", "/notebooks", "/copilot", "/backup", "/system", "/users"];

export const cacheable = (cfg) => (cfg.method || "get").toLowerCase() === "get" && !SKIP.some((s) => (cfg.url || "").includes(s));

const key = (cfg) => PREFIX + (cfg.url || "") + (cfg.params ? "?" + JSON.stringify(cfg.params) : "");

export function cachePut(cfg, data) {
  try {
    const s = JSON.stringify({ t: Date.now(), data });
    if (s.length <= MAX_BYTES) localStorage.setItem(key(cfg), s);
  } catch { /* quota */ }
}

export function cacheGet(cfg) {
  try {
    const raw = localStorage.getItem(key(cfg));
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (Date.now() - o.t > TTL_MS) { localStorage.removeItem(key(cfg)); return null; }
    return o;
  } catch { return null; }
}

export function cacheClear() {
  try { Object.keys(localStorage).filter((k) => k.startsWith(PREFIX)).forEach((k) => localStorage.removeItem(k)); } catch { /* n/a */ }
}
